import React from 'react';
import { useIntl } from 'react-intl';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import desktopBannerImg from './images/desktopBannerImg.png';
import mobileBannerImg from './images/mobileBannerImg.png';
import Banner from '../../components/Banner/Banner';
import SectionsOffsiteConstruction from './Sections/SectionsOffsiteConstruction';
import SectionsVolumetricModular from './Sections/SectionsVolumetricModular';
import SectionsTimberFrame from './Sections/SectionsTimberFrame';
import SectionsFusionLog from './Sections/SectionsFusionLog';
import SectionsLightGaugeSteel from './Sections/SectionsLightGaugeSteel';
import SectionsSpecialProducts from './Sections/SectionsSpecialProducts';

import css from './CustomOffsiteConstructionPage.module.css';

const CustomOffsiteConstructionPage = () => {
  const intl = useIntl();
  return (
    <Page
      title={intl.formatMessage({ id: 'CustomOffsiteConstructionPage.bannerTitle' })}
      description={intl.formatMessage({ id: 'CustomOffsiteConstructionPage.bannerDescription' })}
      scrollingDisabled={false}
    >
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="HowItWorksPage" type="floating" />}
        footer={<FooterContainer />}
      >
        <Banner
          desktopImg={desktopBannerImg}
          mobileImg={mobileBannerImg}
          text={intl.formatMessage({ id: 'CustomOffsiteConstructionPage.bannerTitle' })}
          description={intl.formatMessage({
            id: 'CustomOffsiteConstructionPage.bannerDescription',
          })}
          showBoldTitle
        />
        <SectionsOffsiteConstruction intl={intl} />
        <SectionsVolumetricModular intl={intl} />
        <SectionsTimberFrame intl={intl} />
        <SectionsFusionLog intl={intl} />
        <SectionsLightGaugeSteel intl={intl} />
        <SectionsSpecialProducts intl={intl} />
      </LayoutSingleColumn>
    </Page>
  );
};

export default CustomOffsiteConstructionPage;
